import { Filter } from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import type { BusinessFunnelStep } from '../../types/businessMetrics';
import { buildFunnelStepRows } from '../../types/businessMetricsView';
import { BusinessPanel, NotApplicableNote } from './businessPanelParts';

export const FUNNEL_NOT_COLLECTED_BADGE = '미수집(수집 지점 배포 전)';

export function FunnelPanel({ funnel }: { funnel: { steps: BusinessFunnelStep[] } | null }) {
  if (!funnel) {
    return (
      <BusinessPanel title="구매 퍼널" testId="business-funnel-panel" icon={Filter}>
        <NotApplicableNote reason="이 앱의 퍼널은 아래 기존 퍼널 화면에서 봅니다." />
      </BusinessPanel>
    );
  }
  const rows = buildFunnelStepRows(funnel.steps);
  return (
    <BusinessPanel
      title="구매 퍼널"
      testId="business-funnel-panel"
      icon={Filter}
      footer="전환율은 바로 앞 단계와 이 단계가 모두 수집됐을 때만 계산합니다."
    >
      {rows.length === 0 ? (
        <p className="rounded-md border border-dashed p-3 text-sm text-muted-foreground">퍼널 단계가 없습니다.</p>
      ) : (
        <div className="overflow-x-auto rounded-md border">
          <Table aria-label="구매 퍼널 단계" className="min-w-[480px]">
            <TableHeader>
              <TableRow>
                <TableHead>단계</TableHead>
                <TableHead className="whitespace-nowrap text-right">수</TableHead>
                <TableHead className="whitespace-nowrap text-right">앞 단계 대비</TableHead>
                <TableHead>출처</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.key} data-testid={`business-funnel-step-${row.key}`}>
                  <TableCell>
                    <div className="flex flex-wrap items-center gap-1.5">
                      <span className="font-medium">{row.label}</span>
                      {row.collected ? null : <Badge variant="warning">{FUNNEL_NOT_COLLECTED_BADGE}</Badge>}
                    </div>
                    {row.note ? <p className="mt-1 text-xs text-muted-foreground">{row.note}</p> : null}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-right tabular-nums">{row.countLabel}</TableCell>
                  <TableCell className="whitespace-nowrap text-right tabular-nums">{row.conversionLabel}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{row.source}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </BusinessPanel>
  );
}
